export default {
      id: "api-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#api-usage",
      toString: function () {
        return this.url;
      }
    }